module.exports = __webpack_public_path__ + "media/images/loghi/lba_cares-d083168387dbb6a3780c984dbd6c7415.png";